<app-generic-container>
    <app-generic-panel [title]="panelTitle" [description]="panelDescription" [awesomeIcon]="panelIcon">

        <div class="row" style="margin-bottom: 20px;">
            <div class="col-12">
              <div class="row">
                <div class="col-md col-lg col-xl">
                  <app-company-selector dataSize="7" placeHolder="Empresa" [(ngModel)]="selectedCompany" [gestionEmpleados]="true"
                    [required]="true" [onlyConfigured]="true" (ngModelChange)="onCompanyChange($event)" 
                    (selectedValueChange)="onSelectedValueChange($event)"></app-company-selector>
                </div>
                <div class="col-md col-lg col-xl">
                    <mat-form-field>
                        <mat-select placeholder="Centro" [(ngModel)]="centro">
                            <mat-option [value]="null">-</mat-option>
                            <mat-option *ngFor="let centro of centros" [value]="centro.workplaceCode">{{ centro.workplaceName }}</mat-option>
                          </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-1 col-lg-1 col-xl-1">
                    <mat-form-field>
                        <input matInput type="text"
                          name="codEmpleado"
                          placeholder="Código de empleado"
                          [(ngModel)]="codEmpleado"
                        />
                      </mat-form-field>
                </div>
                <div class="col-md-1 col-lg-1 col-xl-1">
                    <mat-form-field>
                        <input matInput type="text"
                          name="nif"
                          placeholder="NIF"
                          [(ngModel)]="nif"
                        />
                      </mat-form-field>
                </div>
                <div class="col-md col-lg col-xl">
                    <mat-form-field>
                        <input matInput type="text"
                          name="nombreCompleto"
                          placeholder="Nombre y apellidos"
                          [(ngModel)]="nombreCompleto"
                        />
                      </mat-form-field>
                </div>
                <div class="col-md-1 col-lg-1 col-xl-1">
                  <mat-form-field>
                      <input matInput type="text"
                        name="numAfiliacion"
                        placeholder="Nº Afiliación SS"
                        [(ngModel)]="numAfiliacion"
                      />
                    </mat-form-field>
                </div>
                <div class="col-md col-lg col-xl">
                  <mat-form-field>
                    <mat-select placeholder="Tipo de trabajador" [(ngModel)]="tipoTrabajador">
                        <mat-option [value]="null">-</mat-option>
                        <mat-option *ngFor="let tipoTrabajador of personTypes" [value]="tipoTrabajador.id">{{ tipoTrabajador.description }}</mat-option>
                      </mat-select>
                  </mat-form-field>
                </div>
                
                <!-- Botón de búsqueda -->
                <div class="col-md-auto col-lg-auto col-xl-auto">
                  <button class="btn btn-fill btn-primary float-right" [disabled]="!selectedCompany"
                    (click)="onSearch()">Buscar</button>
                </div>
              </div>
            </div>
        </div>

        <dx-data-grid id="gridContainer" [dataSource]="dataSource"  [columnChooser]="false"  [showBorders]="true" (onToolbarPreparing)="onToolbarPreparing($event)" (onEditorPreparing)="onEditorPreparing($event)">

            <dxo-export [enabled]="true"></dxo-export>
      
            <!-- Definición de las columnas -->
            <dxi-column caption="Centro" alignment="center">
                <dxi-column dataField="workplaceCode" caption="Código" alignment="center"> </dxi-column>
                <dxi-column dataField="workplaceName" caption="Centro" alignment="center"> </dxi-column>
            </dxi-column>

            <dxi-column caption="Empleado" alignment="center">
              <dxi-column dataField="employeeCode" caption="Cód. empleado" alignment="center"> </dxi-column>
              <dxi-column dataField="completeName" caption="Nombre completo"> </dxi-column>
              <dxi-column dataField="personTypeDescription" caption="Tipo trabajador" alignment="center"> </dxi-column>
              <dxi-column dataField="companyName" caption="Empresa" alignment="center"></dxi-column>            
              <dxi-column dataField="identifierNumber" caption="NIF" alignment="center"> </dxi-column>
              <dxi-column dataField="ssNAF" caption="Nº Afiliación SS" alignment="center"> </dxi-column>
            </dxi-column>
      
            <!-- Templates -->
            <ng-container *ngIf="isCrud">
              <dxi-column dataField="employeeCode"  [allowExporting]="false" caption="Acciones" [allowFiltering]="false" [allowSorting]="false" alignment="center" cellTemplate="buttonCRUDTemplate"></dxi-column>
              <ng-container *dxTemplate="let data of 'buttonCRUDTemplate'">
                <button rel="tooltip" type="button" class="btn btn-success btn-action" (click)="onClickEditEmpleados(data.value, selectedCompany)">
                  <i class="material-icons">edit</i>
                </button>
                <!-- <button rel="tooltip" type="button" class="btn btn-danger btn-action" (click)="onClickDelete(data.value, data.rowIndex)">
                  <i class="material-icons">close</i>
                </button> -->
              </ng-container>
            </ng-container>
      
            <!-- Añadir nuevos -->
            <div *dxTemplate="let data of 'addNew'">
              <button class="btn btn-primary btn-sm btn-add" (click)="onClickAdd()">
                <i class="material-icons">add</i> <span class="d-none d-sm-inline-block">Nuevo</span></button>
            </div>
      
          </dx-data-grid>
    </app-generic-panel>
</app-generic-container>
